var React = require('react');

function BbLogoRedInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M70.1776 49.5576H45.5016V74.0002H70.1776V49.5576Z","fill":"#B6252F","key":0}),React.createElement("path",{"d":"M41.6562 69.9873H0L28.3003 0H40.5252L58.6364 45.6313H41.5431L41.6562 69.9873Z","fill":"#B6252F","key":1})]);
}

BbLogoRedInline.defaultProps = {"width":"71","height":"74","viewBox":"0 0 71 74","fill":"none"};

module.exports = BbLogoRedInline;

BbLogoRedInline.default = BbLogoRedInline;
